<template>
    <div
        :class="headerClass"
        @click="handleClick"
    >
        <Status
            :status="status"
            :numEventsLeft="numEventsLeft"
            :liveIndicator="hasOngoingEvents"
        />
        <div class="tickets-widget__title">
            <div class="tickets-widget__title-type">
                <span class="">{{ $t(type) }}</span>
                <div class="delimiter"></div>
                <span class="">{{ betSlipTypeDisplay }}</span>
                <span class="">{{ quotaDisplay }}</span>
            </div>
            <div class="tickets-widget__title-details">
                <span @click="handleCodeClick" class="">{{ isExpanded ? id : payout }}</span>
                <span
                    v-if="!isExpanded"
                    class="currency"
                >
                    {{$t('currencyAbbreviation') }}
                </span>
            </div>
        </div>
        <i
            class="icon--sm icon-close"
            @click.stop="onCloseClick"
        ></i>
    </div>
</template>

<script>
    import { twoDecimals } from '@shared/filters';
    import Status from '@modules/shared/tickets/Status.vue';

    export default {
        name: 'TicketHeader',
        props: {
            id: {
                type: String,
                required: true,
            },
            status: {
                type: String,
                required: true,
            },
            isHighlighted: {
                type: Boolean,
                default: false,
            },
            isExpanded: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                required: true,
            },
            potentialWin: {
                type: Number,
                required: true,
            },
            payoff: {
                type: Number,
                required: true,
            },
            isWon: {
                type: Boolean,
                required: true
            },
            coefficient: {
                type: Number,
                required: true,
            },
            // props used in children
            system: {
                type: Object,
                default: null,
            },
            numEventsLeft: {
                type: Number,
                required: true
            },
            hasOngoingEvents: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        computed: {
            headerClass() {
                return {
                    'tickets-widget__header': true,
                    highlighted: this.isHighlighted,
                };
            },
            betSlipTypeDisplay() {
                if (this.isExpanded) {
                    const type = this.system ? 'system' : 'simple';
                    return this.$t(type).toUpperCase();
                }
                if (this.system) {
                    return this.$t('system').toUpperCase();
                }

                return '';
            },
            quotaDisplay() {
                return !this.isExpanded && !this.system ? twoDecimals(this.coefficient) : '';
            },
            payout() {
                return twoDecimals(this.isWon ? this.payoff : this.potentialWin);
            },
        },
        methods: {
            handleClick() {
                const selection = window.getSelection();
                if (this.isExpanded && selection.toString() === this.id) {
                    return;
                }
                this.$emit('click', this.id);
            },
            handleCodeClick(event) {
                if (this.isExpanded) {
                    const selection = window.getSelection();
                    if (selection.toString().length
                        && selection.baseNode === selection.focusNode) {
                        event.stopPropagation();
                    }
                }
            },
            onCloseClick() {
                this.$emit('close', this.id);
            },
        },
        components: {
            Status,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/TicketHeader.vue